import {
  PEER_REQUEST, GET_PEER_UNASSIGNED_SUCCESS, GET_PEER_CONNECTED_SUCCESS,
  ASSIGN_PEER_DEVICE_SUCCESS, PEER_TUNNEL_STATUS_SUCCESS, PEER_WG_HEALTH_SUCCESS,
  GET_APP_VERSIONS_SUCCESS, PEER_FLAG_OFF, PEER_REQUEST_FAILED,
} from '../constant';

const initial = {
  unassigned: [],
  connected: [],
  tunnelStatus: { peers: [], total: 0 },
  wgHealth: {},
  appVersions: [],
  loading: false,
  error: null,
};

export const peerReducer = (state = initial, action) => {
  switch (action.type) {
    case PEER_REQUEST:
      return { ...state, loading: true };
    case GET_PEER_UNASSIGNED_SUCCESS:
      return { ...state, loading: false, unassigned: action.payload };
    case GET_PEER_CONNECTED_SUCCESS:
      return { ...state, loading: false, connected: action.payload };
    case ASSIGN_PEER_DEVICE_SUCCESS:
      return { ...state, loading: false };
    case PEER_TUNNEL_STATUS_SUCCESS:
      return { ...state, loading: false, tunnelStatus: action.payload };
    case PEER_WG_HEALTH_SUCCESS:
      return { ...state, loading: false, wgHealth: action.payload };
    case GET_APP_VERSIONS_SUCCESS:
      return { ...state, loading: false, appVersions: action.payload };
    case 'ADD_APP_VERSION_SUCCESS':
      return { ...state, appVersions: [action.payload, ...state.appVersions] };
    case 'REMOVE_PEER_DEVICE':
      return { ...state, loading: false };
    case PEER_FLAG_OFF:
      return { ...state, loading: false };
    case PEER_REQUEST_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
